export const NOTIFICATION_ROUTE_PREFIX = "/notifications";

export const NOTIFICATION_ROUTE_PATHS = {
  list: { path: "*", to: NOTIFICATION_ROUTE_PREFIX },
};
